import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages1Alt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconImages1Alt"><Path fillRule="evenodd" clipRule="evenodd" d="M18.5 3C19.8807 3 21 4.11929 21 5.5V18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.11929 21 3 19.8807 3 18.5V5.5C3 4.11929 4.11929 3 5.5 3H18.5ZM9.06055 13.0605C8.47479 12.4749 7.52521 12.4749 6.93945 13.0605L4 16V18.5C4 19.3284 4.67157 20 5.5 20H16L9.06055 13.0605ZM15 7C13.8954 7 13 7.89543 13 9C13 10.1046 13.8954 11 15 11C16.1046 11 17 10.1046 17 9C17 7.89543 16.1046 7 15 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImages1Alt;
